import { useI18n } from 'vue-i18n';
import * as DateUtils from '@/helpers/dateUtils';

export function useValidationRules() {
  const { t, te, locale } = useI18n();
  
  const required = (message: string) => (v: any) =>
    (typeof v === 'string' ? v.trim().length > 0 : !!v) || message;

  const minCount = (min: number, message: string) => (v: number) =>
    (typeof v === 'number' ? v >= min : false) || message;


  const passportNumberRule = required(
    te('profile.passportNumberRequired') ? t('profile.passportNumberRequired') : 'Passport number is required'
  );
  

  const passportExpiryDateRule = (v: string) => {
    const reqMsg = te('profile.passportExpiryDateRequired')
      ? t('profile.passportExpiryDateRequired')
      : 'Passport expiry date is required';
    const fmtMsg = te('profile.invalidDateDdMmYyyy')
      ? t('profile.invalidDateDdMmYyyy')
      : DateUtils.getDateMaskAndPlaceholder(locale.value).placeholder;
    const pastMsg = te('profile.passportExpiryDateInPast')
      ? t('profile.passportExpiryDateInPast')
      : 'Passport expiry date cannot be in the past';

    if (!v) return reqMsg;
    const date = DateUtils.parseLocaleDate(v, locale.value);
    if (!date) return fmtMsg;
    return DateUtils.isTodayOrFuture(date) || pastMsg;
  };

  return {
    required,
    minCount,
    passportNumberRule,
    passportExpiryDateRule,
  };
}